(function ($) {

	'use strict'

	var init = function() {

		$('.map__item__close').on('click', closeInfoWindow);

		initMap();

	}
	
	var initMap = function(){
		var style = [
			{
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#F5F5F5"
				}
			  ]
			},
			{
			  "elementType": "labels.icon",
			  "stylers": [
				{
				  "visibility": "off"
				}
			  ]
			},
			{
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#616161"
				}
			  ]
			},
			{
			  "elementType": "labels.text.stroke",
			  "stylers": [
				{
				  "color": "#F5F5F5"
				}
			  ]
			},
			{
			  "featureType": "administrative.land_parcel",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#BDBDBD"
				}
			  ]
			},
			{
			  "featureType": "poi",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#EEEEEE"
				}
			  ]
			},
			{
			  "featureType": "poi",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#757575"
				}
			  ]
			},
			{
			  "featureType": "poi.park",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#E5E5E5"
				}
			  ]
			},
			{
			  "featureType": "poi.park",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#9E9E9E"
				}
			  ]
			},
			{
			  "featureType": "road",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#FFFFFF"
				}
			  ]
			},
			{
			  "featureType": "road.arterial",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#757575"
				}
			  ]
			},
			{
			  "featureType": "road.highway",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#DADADA"
				}
			  ]
			},
			{
			  "featureType": "road.highway",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#616161"
				}
			  ]
			},
			{
			  "featureType": "road.local",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#9E9E9E"
				}
			  ]
			},
			{
			  "featureType": "transit",
			  "stylers": [
				{
				  "visibility": "off"
				}
			  ]
			},
			{
			  "featureType": "transit.line",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#E5E5E5"
				}
			  ]
			},
			{
			  "featureType": "transit.station",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#EEEEEE"
				}
			  ]
			},
			{
			  "featureType": "water",
			  "elementType": "geometry",
			  "stylers": [
				{
				  "color": "#26358C"
				}
			  ]
			},
			{
			  "featureType": "water",
			  "elementType": "labels.text.fill",
			  "stylers": [
				{
				  "color": "#9E9E9E"
				}
			  ]
			}
		]

		if($('.map').length > 0) {       
            initMap();
			$('.map__item__close').on('click', closeInfoWindow);
        }
		
	}

	var initMap = function () {
		var tileUrl = 'https://maps.geoapify.com/v1/tile/osm-liberty/{z}/{x}/{y}.png?apiKey=218483ba811e467eadbcdac1906953b7';
		var mapTiles = L.tileLayer(tileUrl);

		var map = L.map('map', {
			center: [48.083, -2.772],
			zoom: 8,
			layers: [mapTiles],
		});

		var markerOB = L.icon({
			iconUrl: GMAP_CI.icon,
			iconSize: [40, 40],
			iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
		});

		for (var id in GMAP_CI.markers) {
			var item = GMAP_CI.markers[id];
			if(!(item.lat && item.lng)){
				return ;
			}
			var marker = L.marker([item.lat, item.lng], { icon: markerOB }).addTo(map);

			marker.on('click', openInfoWindow);
		}

		L.tileLayer(tileUrl, {
			maxZoom: 19,
			attribution: 'Powered by <a href="https://www.geoapify.com/" target="_blank">Geoapify</a> | © OpenStreetMap <a href="https://www.openstreetmap.org/copyright" target="_blank">contributors</a>'
		}).addTo(map);

	}

	var openInfoWindow = function () {
		var markerLat = this._latlng.lat;
		var markerLng = this._latlng.lng;

		for (var id in GMAP_CI.markers) {
			var item = GMAP_CI.markers[id];
			var itemLat = item.lat;
			var itemLng = item.lng;
			$('[data-id="' + item.id + '"]').removeClass('active');

			if (markerLat == itemLat && markerLng == itemLng) {
				$('[data-id="' + item.id + '"]').addClass('active');
			}
		}
	}

	var closeInfoWindow = function () {
		var item = $(this).closest('.map__item');
		var id = item.data('id');
		$('[data-id="' + id + '"]').removeClass('active');
	}

	$(document).ready(function () {
		if ($('section.map').length > 0) {
			init();
		}
	});

})(jQuery)